import builder from '../builder';
import ArrowButtonDown2Alternate from '../../streamline-icons/bold/arrow-button-down-2-alternate.svg';

export default builder(
  'IconArrowButtonDown2AlternateBold',
  ArrowButtonDown2Alternate,
);
